import { SelectedFilter } from '@react/Filterbar/Filters/FiltersTypes'

import { arrayFromSearchQueryParams, setFiltersFromQueryParams } from '../helpers'

interface UrlParamsHandlerProps {
  prefix: string
  offsetState: string[]
  calculatedOffsetState: string[]
  setOffsetState: (value: string[]) => void
  setCalculatedOffsetState: (value: string[]) => void
  setIsFilterbarLoaded: (value: boolean) => void
  setSelectedFilters: (filters: SelectedFilter[]) => void
}

export const urlParamsHandler = ({
  prefix,
  offsetState,
  calculatedOffsetState,
  setOffsetState,
  setCalculatedOffsetState,
  setIsFilterbarLoaded,
  setSelectedFilters,
}: UrlParamsHandlerProps) => {
  const queryParams = arrayFromSearchQueryParams()
  const selectedFilters: SelectedFilter[] = []

  if (queryParams.length) {
    setFiltersFromQueryParams({ queryParams, selectedFilters, prefix, setOffsetState, setCalculatedOffsetState })
    const isOffsetPresent = selectedFilters.some(filter => filter.key === 'offset')
    const isCalculatedOffsetPresent = selectedFilters.some(filter => filter.key === 'calculatedOffset')

    if (!isOffsetPresent) {
      selectedFilters.push({ key: 'offset', value: offsetState })
    }
    if (!isCalculatedOffsetPresent) {
      selectedFilters.push({ key: 'calculatedOffset', value: calculatedOffsetState })
    }
  } else {
    selectedFilters.push({ key: 'offset', value: ['0'] })
    selectedFilters.push({ key: 'calculatedOffset', value: ['0'] })
  }

  setIsFilterbarLoaded(false)
  setSelectedFilters(selectedFilters)
}
